import React, {useState} from 'react';
import Select from '../../common/Select.jsx';
import Help from '../../common/Help.jsx';
import { Button } from '../../bootstrap/index.jsx';
import {
    datagrid_update_import_config_path
} from '~/routes';

const VISIBILITY_OPTIONS = [
    {label: I18n.t('personal'), value: 'personal'},
    {label: I18n.t('public'), value: 'public'}
]

export default function ImportConfigModification({
    selectedColConfig,
    configuration,
    context,
    allConfigs = [],
    setAllConfigs,
    setSelectedColConfig
}) {
    const chosenSetting = allConfigs.find(c => c.id === selectedColConfig) ?? {}
    const [name, setName] = useState(chosenSetting.name || '');
    const [visibility, setVisibility] = useState(chosenSetting.visibility);
    const [saving, setSaving] = useState(false);

    const saveConfig = (configOption) => {
        setSaving(true);
        const body = {name, visibility};
        const names = allConfigs.map(c => c.name);
        if (name.length > 0 && visibility){
            const params = {id: context.id, project_id: context.project_id, _options: true};
            if (configOption === 'update'){
                params.config_id = selectedColConfig;
            }
            if (configOption === 'new' && names.includes(name)){
                window.ToastNotification({message: I18n.t('duplicate_datagrid_config'), horizontal: 'center', autoHideDuration: 5});
                setSaving(false);
                return;
            }
            jQuery.post(datagrid_update_import_config_path(params), {name, visibility, configuration}, (res) => {
                setSaving(false);
                setAllConfigs(res.all_configs);
                setSelectedColConfig(res.current_config);
                window.ToastNotification({message: I18n.t('datagrid_config_saved'), horizontal: 'center', autoHideDuration: 5});
            }).error(() => {setSaving(false)})
        } else {
            let missingFields = []
            Object.keys(body).forEach(k => {
                if (!body[k]){
                    missingFields.push(I18n.t(k));
                }
            })
            window.ToastNotification({message: I18n.t('datagrid_save_config_error', {fields: missingFields.join(', ')}), horizontal: 'center', autoHideDuration: 5});
            setSaving(false);
        }
        
    }

    return (
        <div>
            <div className='form-group'>
                <label>{I18n.t('name')} *</label>
                <input
                    className='form-control'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </div>

            <div className='form-group'>
                <label>
                    {I18n.t('visibility')} *
                    <Help text={I18n.t("datagrid_import_config_visibility_info")} trigger="hover" className='mapbox-help-container' />
                </label>
                <Select
                    options={VISIBILITY_OPTIONS}
                    value={visibility}
                    onChange={(val) => setVisibility(val)}
                />
            </div>
            <div className='d-flex mt-1'>
                {
                    selectedColConfig && context.person_id === chosenSetting.person_id &&
                    <Button type='default' disabled={saving} className='pull-left mr-2' onClick={() => saveConfig('update')}>
                        {I18n.t('save_current_config')}
                    </Button>
                }
                <Button type='default' disabled={saving} className='pull-left' onClick={() => saveConfig('new')}>
                    {selectedColConfig ? I18n.t('save_as_new') : I18n.t('save_column_config')}
                </Button>
            </div>
        </div>
    )
}
